import {all} from 'redux-saga/effects';
import {fetchDemoWatcherSag} from './sagas/index';

export function* rootSaga() {
    yield all([
        fetchDemoWatcherSag()
    ]);
}
